import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
};
export const ComparisonIncrease = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(9);
  let backgroundColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = props;
  } else {
    backgroundColor = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== backgroundColor) {
    t1 = <path d="M11.134 6.5C11.5189 5.83333 12.4811 5.83333 12.866 6.5L18.0622 15.5C18.4471 16.1667 17.966 17 17.1962 17H6.80385C6.03405 17 5.55292 16.1667 5.93782 15.5L11.134 6.5Z" fill={backgroundColor} />;
    $[3] = backgroundColor;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}</svg>;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});